// file: CartBundleDetails.jsx
import React, { useState } from "react";

import styles from "./CartBundleDetails.module.scss";
import CartBundleTile from "../../components/uiComponents/cartBundleTile/CartBundleTile";
import AddressTile from "../../components/uiComponents/addressTile/AddressTile";
import TimeStamp from "../../components/uiComponents/timeStamp/TimeStamp";
import { useLocation, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import ToggleSwitch from "../../components/customComponents/toggleSwitch/ToggleSwitch";
import OrderModal from "../../components/customComponents/orderModal/OrderModal";
import PackageDetails from "../../components/uiComponents/packageDetails/PackageDetails";
import {
  createShipment,
  updateOrderStatusByCartBundleId,
} from "../../store/actions";

const initialState = {
  type: "",
  length: "",
  breadth: "",
  height: "",
  weight: "",
};

const CartBundleDetailsPackager = ({ cartBundleId, user }) => {
  const location = useLocation();
  const [packageData, setPackageData] = useState(initialState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log("cartBundleId", cartBundleId);

  console.log("user", user);
  //   const[isOn, setIson] = useState(true)
  const { id, page } = location?.state;

  const updatePackage = () => {
    dispatch(
      createShipment({
        cartBundleId: id,
        addressId: cartBundleId?.address?.id,
        shipment_height: Number(packageData?.height),
        shipment_width: Number(packageData?.breadth),
        shipment_length: Number(packageData?.length),
        weight: Number(packageData?.weight),
        plastic_packaging: packageData?.type === "0" ? true : false,
        callback: {
          success: () =>
            dispatch(
              updateOrderStatusByCartBundleId({
                id: id,
                status: 1,
                callback: {
                  success: () => {
                    navigate(-1);
                  },
                },
              })
            ),
        },
      })
    );
  };

  const updatePacakgeData = (key, value) => {
    setPackageData((prev) => {
      return { ...prev, [key]: value };
    });
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>CART BUNDLE ID : {id}</h1>
        <div className={styles.statusSelector}>
          {page === "pending" && (
            <ToggleSwitch
              value={"packager"}
              cartBundleId={id}
              cartBundleData={cartBundleId}
            />
          )}
        </div>
      </div>

      <div className={styles.topSection}>
        <div className={styles.leftTop}>
          <CartBundleTile cartBundleData={cartBundleId} />
        </div>
        <div className={styles.rightTop}>
          <AddressTile cartBundleData={cartBundleId} />
          {page === "pending" && (
            <PackageDetails
              handleSaveChange={updatePackage}
              handleChange={updatePacakgeData}
              packageData={packageData}
            />
          )}
        </div>
      </div>

      <div className={styles.bottomSection}>{/* <TimeStamp /> */}</div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    cartBundleId: state?.orders?.cartBundleId,
    user: state.login?.user,
  };
};
export default connect(mapStateToProps, null)(CartBundleDetailsPackager);
